import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import "./magzine.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import {
  deleteVideo,
  //   getVideos,
  postVideoUpdate,
} from "../../../store/Action/videoAction";
import axios from "axios";
import { deleteMagzine } from "../../../store/Action/magzineAction";
import Pagination from "../../../Pagination";
import moment from "moment";
import MagazineSubscriberForm from "./MagazineSubscriberForm";
function MagazineSubscriber() {
  const dispatch = useDispatch();
  const apiUrl = process.env.REACT_APP_BACKEND_URL;
  //   const [videos, setVideos] = useState([]);
  const [magazineForms, setMagazineForms] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState("");
  const [showDetails, setShowDetails] = useState({});

  const [deletes, setDelete] = useState(1);
  const itemsPerPage = 12; // Change this to the desired number of items per page

  // Logic to calculate total pages
  // const queryParams = { page: currentPage, perPage: itemsPerPage };

  // Fetch categories and total count from API or any data source
  useEffect(() => {
    const fetchMagzine = async () => {
      try {
        const response = await axios.get(`${apiUrl}getAllForms`);
        if (response) {
          //   console.log(response, "magazine subscribers");
          setMagazineForms(response?.data?.data); // Update with the correct field name from your API response
          // console.log(response, "magazine subscribers");
        }
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    };

    fetchMagzine();
  }, [dispatch, currentPage, deletes]);

  const nextPage = () => {
    if (magazineForms.length === itemsPerPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const handleDelete = (categoryId) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      const response = dispatch(deleteMagzine(categoryId));
      if (response) {
        setDelete(response);
      }
    }
  };
  // console.log(magazineForms, "maga");

  return (
    <div className="manage-category">
      <div className="card magazine-subscriber">
        <div className="card-header">Manage Magzine</div>
        <div className="card-body">
          <table className="table">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Plan Selected</th>
                <th scope="col">Ph. No.</th>
                <th scope="col">E mail.</th>
                <th scope="col">End Date</th>
                <th scope="col">Address</th>
                <th scope="col">status</th>
                {/* <th scope="col">View Details</th> */}
              </tr>
            </thead>
            <tbody>
              {magazineForms?.map((item) => (
                <tr key={item._id}>
                  <td>
                    <b>{item.fullName}</b>
                  </td>
                  <td>{item.subscriptionType}</td>
                  <td>{item.phoneNumber}</td>
                  <td>{item.email}</td>
                  <td>
                    {moment(item.subscriptionEndDate).format("DD-MM-YYYY")}
                  </td>
                  {item.shippingAddress ? (
                    <td>
                      {item.shippingAddress.house},{" "}
                      {item.shippingAddress.street},{" "}
                      {item.shippingAddress.landmark},{" "}
                      {item.shippingAddress.city}, {item.shippingAddress.state}
                    </td>
                  ) : (
                    <td> ---- </td>
                  )}
                  {/* <td>{JSON.stringify(item.shippingAddress)}</td> */}
                  <td>{item.subscriptionStatus}</td>
                  {/* <td onClick={() => setShowDetails(item)}>
                    <Link to={`/magazine-subscriber-form/${item.userId}`}>
                    View Details
                    </Link>
                  </td> */}
                  {/* <td onClick={() => handleDetails(item.userId)}>
                    <button>View</button>
                  </td> */}
                  {/* <td>
                    <Link to={`/editmagzine/${item._id}`}>
                      <button className="action-button">
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </Link>

                    <button
                      className="action-button"
                      onClick={() => handleDelete(item._id)}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
          {/* {showDetails && <MagazineSubscriberForm data={showDetails} />} */}
          <div className="card-footer bg-transparent border-secondary d-flex justify-content-center">
            <div className="pagination">
              <button
                className="pagination-btn"
                onClick={prevPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span className="current-page">{currentPage}</span>

              <button
                className="pagination-btn"
                onClick={nextPage}
                disabled={magazineForms?.length < itemsPerPage}
              >
                {magazineForms?.length < itemsPerPage ? "" : "Next"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MagazineSubscriber;
